
define('text!views/secured/explorer/details/noDocument.html',[],function () { return '<div id="explorer-details-no-document" class="page-content clearfix">\r\n    <h3 data-bind="text: i19n.to.nodocumentselected"></h3>\r\n</div>';});

